/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Tipi di evento calendario. Tipi previsti:   -*PASTA_IN_BIANCO*  -*ANNULLATO*
 */
export type EventoCalendarioType = 'PASTA_IN_BIANCO' | 'ASSENZA';

export const EventoCalendarioType = {
    PASTAINBIANCO: 'PASTA_IN_BIANCO' as EventoCalendarioType,
    ASSENZA: 'ASSENZA' as EventoCalendarioType
};